const caseStudiesData = [
  {
    id: 1,
    company: "Pizzeria Bella Italia",
    title: "How a Small Pizzeria Boosted Sales With Automation",
    problem:
      "Bella Italia was struggling with order overload, delayed responses, and high walk-in wait times.",
    metrics: [
      { value: "47%", label: "Increase in Reservations" },
      { value: "<30s", label: "Response Time" },
      { value: "98%", label: "Customer Satisfaction" },
    ],
    keyResults: [
      "Automated 85% of inquiries",
      "Reduced staff workload 60%",
      "Repeat customers +35%",
    ],
    testimonial:
      "Our customers love the instant responses—our rush hours are finally under control!",
    author: "— Owner, Bella Italia",
  },
  {
    id: 2,
    company: "Oceanview Seafood Grill",
    title: "Improving Customer Flow With Automated Reservations",
    problem:
      "Oceanview needed an automated way to manage busy evenings and reservation bottlenecks.",
    metrics: [
      { value: "55%", label: "Fewer Wait Complaints" },
      { value: "Automated", label: "Menu + Location Sends" },
      { value: "20%", label: "Fewer No-shows" },
    ],
    keyResults: [
      "Automated bookings & menus",
      "Reduced no-shows 20%",
      "Faster guest confirmations",
    ],
    testimonial:
      "The AI handles everything—guests get menu, location, and booking instantly!",
    author: "— Manager, Oceanview Grill",
  },
  {
    id: 3,
    company: "The Green Leaf Café",
    title: "Growing Customer Engagement With Smart Replies 24/7",
    problem:
      "Green Leaf Was Losing Customers Due to Slow Staff Replies During Peak Hours.",
    metrics: [
      { value: "4x", label: "Faster Replies" },
      { value: "Instant", label: "Staff Contact Linking" },
      { value: "Improved", label: "Customer Satisfaction" },
    ],
    keyResults: [
      "Replies 4x faster",
      "Instant staff contact",
      "Higher satisfaction scores",
    ],
    testimonial:
      "We finally provide professional service even during the busiest hours!",
    author: "— Owner, Green Leaf Café",
  },
];

export default caseStudiesData;
